var map = {
	"./Etsy.svg": "7f8a42650ff3d57a7d8b",
	"./Facebook.svg": "44164fdb9a4db877d98e",
	"./Gmaps.svg": "ace6eb1498086cfb81f5",
	"./Instagram.svg": "7bae8b5e84cd937579da",
	"./Linkedin.svg": "8a5d98f07a16c176bcc9",
	"./Linktree.svg": "866d0f7021498a851012",
	"./Opencorporates.svg": "ded266ed2e9c496e66de",
	"./Pinterest.svg": "80ba6e33c2ea11866ce1",
	"./Shopify.svg": "ed96441cbcdab7ea9957",
	"./Tiktok.svg": "6b7929ca6e30bdf401bd",
	"./Twitter.svg": "b0d7ec8bed71291ee53e",
	"./Website.svg": "e6f4ac24cb5d9b13695a",
	"./Youtube.svg": "d0383dbf70ac93383508"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8c6421cf7b064e165d08";